import { render } from "./signature.vue?vue&type=template&id=413e5b13"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/signature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "413e5b13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('413e5b13', __exports__)) {
    console.log('reload')
    api.reload('413e5b13', __exports__)
  }
  
  module.hot.accept("./signature.vue?vue&type=template&id=413e5b13", () => {
    console.log('re-render')
    api.rerender('413e5b13', render)
  })

}


export default __exports__